import React, { useState } from 'react';

import LoginForm from './login-form';
import { useQueryString } from '../../hooks/useQueryString';
import { api } from '../../api/restApi';

const Login = () => {
  const [error, setError] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [resetting, setResetting] = useState(false);

  const values = useQueryString();

  const handleLogin = async (
    username,
    password,
    rememberUser,
    next = '',
    isShopifyEmbedded = false,
  ) => {
    setError(false);
    setSubmitting(true);
    setResetting(false);

    const payload = {
      username,
      password,
      is_shopify_embedded: isShopifyEmbedded,
    };

    /**
     * If the request comes from the Shopify embedded
     * app, we need to pull off the necessary params and re-inject them
     * into the redirect URL.
     **/
    const buildNextUriParams = () => {
      if (!isShopifyEmbedded) return '';

      const { session, locale, timestamp, hmac, shop, host } = values;
      const stringifiedParams = new URLSearchParams({
        host,
        session,
        locale,
        timestamp,
        hmac,
        shop,
      }).toString();

      return `?${stringifiedParams}`;
    };

    try {
      const response = await api({
        method: 'POST',
        url: '/login',
        data: payload,
      });

      if (response.status === 200) {
        setSubmitting(false);
        const redirectParams = buildNextUriParams();
        const redirectUri = next + redirectParams;

        window.location.href = redirectUri || '/';
      }
    } catch (err) {
      setError(true);
      setSubmitting(false);
      setResetting(true);
    }
  };

  return (
    <LoginForm
      allowRememberUser={false}
      error={error}
      handleLogin={handleLogin}
      resetting={resetting}
      submitting={submitting}
    />
  );
};

export default Login;
